"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isICardRenderRoot = isICardRenderRoot;
exports.isICardRenderSymbol = isICardRenderSymbol;
exports.isICardRenderTile = isICardRenderTile;
exports.isICardRenderProductionBox = isICardRenderProductionBox;
exports.isICardRenderEffect = isICardRenderEffect;
exports.isICardRenderCorpBoxEffect = isICardRenderCorpBoxEffect;
exports.isICardRenderCorpBoxAction = isICardRenderCorpBoxAction;
exports.isICardRenderCorpBoxEffectAction = isICardRenderCorpBoxEffectAction;
exports.isICardRenderItem = isICardRenderItem;
function isICardRenderRoot(item) {
    return typeof (item) !== 'string' && item?.is === 'root';
}
function isICardRenderSymbol(item) {
    return typeof (item) !== 'string' && item?.is === 'symbol';
}
function isICardRenderTile(item) {
    return typeof (item) !== 'string' && item?.is === 'tile';
}
function isICardRenderProductionBox(item) {
    return typeof (item) !== 'string' && item?.is === 'production-box';
}
function isICardRenderEffect(item) {
    return typeof (item) !== 'string' && item?.is === 'effect';
}
function isICardRenderCorpBoxEffect(item) {
    return typeof (item) !== 'string' && item?.is === 'corp-box-effect';
}
function isICardRenderCorpBoxAction(item) {
    return typeof (item) !== 'string' && item?.is === 'corp-box-action';
}
function isICardRenderCorpBoxEffectAction(item) {
    return typeof (item) !== 'string' && item?.is === 'corp-box-effect-action';
}
function isICardRenderItem(item) {
    return typeof (item) !== 'string' && item?.is === 'item';
}
